import service from '@/middleware'

const countryApi = {
    
    /**
     * Para obtener un arreglo de los países de la base de datos
     */
    async getCountries() {
        const result = await service.http.get(`/api/country`)
        return result
    },

    /**
     * Para obtener un arreglo de provincias / estados de la base de datos
     * @param {*} countryId
     */
    async getProvinces(countryId) {
        const result = await service.http.get(`/api/country/provinces/${countryId}`)
        return result
    },

    /**
     * Para obtener un arreglo de las ciudades de la base de datos
     * @param {*} countryId
     * @param {*} provinceId
     */
    async getCities(countryId, provinceId) {
        const result = await service.http.get(`/api/country/cities/${countryId}/${provinceId}`)
        return result
    }

}

export default countryApi
